import { randomUUID } from '../uuid.js';

export class Player {
  constructor({
    id = randomUUID(),
    name,
    token,
    color,
    money = 1500,
    position = 0,
    properties = [],
    jail = { inJail: false, turns: 0 },
    jailFreeCards = 0,
    bankrupt = false,
    connectionStatus = 'online',
    disconnectedAt = null,
    reconnectDeadline = null,
    isBot = false,
  }) {
    this.id = id;
    this.isBot = isBot;
    this.name = name;
    this.token = token;
    this.color = color;
    this.money = money;
    this.position = position;
    this.properties = properties.map(Number);
    this.jail = { inJail: Boolean(jail?.inJail), turns: Number(jail?.turns ?? 0) };
    this.jailFreeCards = jailFreeCards;
    this.bankrupt = bankrupt;
    this.connectionStatus = connectionStatus;
    this.disconnectedAt = disconnectedAt;
    this.reconnectDeadline = reconnectDeadline;
  }

  get connected() {
    return this.connectionStatus === 'online';
  }

  set connected(value) {
    this.connectionStatus = value ? 'online' : 'offline';
  }

  markOnline() {
    this.connectionStatus = 'online';
    this.disconnectedAt = null;
    this.reconnectDeadline = null;
  }

  markReconnecting(now = Date.now(), graceMs = 10 * 60 * 1000) {
    this.connectionStatus = 'reconnecting';
    this.disconnectedAt = now;
    this.reconnectDeadline = now + graceMs;
  }

  markOffline() {
    this.connectionStatus = 'offline';
  }

  toSnapshot() {
    return {
      id: this.id,
      isBot: this.isBot,
      name: this.name,
      token: this.token,
      color: this.color,
      money: this.money,
      position: this.position,
      properties: [...this.properties],
      jail: { ...this.jail },
      jailFreeCards: this.jailFreeCards,
      bankrupt: this.bankrupt,
      connectionStatus: this.connectionStatus,
      disconnectedAt: this.disconnectedAt,
      reconnectDeadline: this.reconnectDeadline,
    };
  }

  static fromSnapshot(snapshot) {
    return new this(snapshot);
  }

  toPublic() {
    return {
      id: this.id,
      isBot: this.isBot,
      name: this.name,
      token: this.token,
      color: this.color,
      money: this.money,
      position: this.position,
      properties: [...this.properties],
      jail: { ...this.jail },
      jailFreeCards: this.jailFreeCards,
      bankrupt: this.bankrupt,
      connected: this.connected,
      connectionStatus: this.connectionStatus,
      disconnectedAt: this.disconnectedAt,
      reconnectDeadline: this.reconnectDeadline,
    };
  }
}
